import http from '@/utils/http';

/**
 * 获取用户性别信息
 */
export const getUserSex = () => {
    return http({
        url: '/api/area/v2/userInfo/sex',
        method: 'get'
    });
};

/**
 * 用户年龄分布
 */
export const getUserYear = () => {
    return http({
        url: '/api/area/v2/userInfo/year',
        method: 'get'
    });
};





//  消息通知栏 center
export const schooolMessage = (params) => {
    return http({
        url: '/api/visual/v2/index/message',
        params
    })
}
//  学校信息
export const schoolInfo = (params) => {
    return http({
        url: '/api/visual/v2/index/courseRecord',
        params
    })
}
// 融合教学热点问题
export const schoolResources = (params) => {
    return http({
        url: '/api/visual/v2/index/teachingResources',
        params
    })
}
//  融合学生人数(分学段按月统计)
export const schoolStudent = (params) => {
    return http({
        url: '/api/visual/v2/index/student',
        params
    })
}
// 学校数量
export const schoolNumS = (params) => {
    return http({
        url: '/api/visual/v2/index/school/count',
        params
    })
}
// 远程指导次数
export const remote = (params) => {
    return http({
        url: '/api/visual/v2/index/remote',
        params
    })
}



//  获取区县信息
export function countyMine() {
    return http({
        url: '/api/rongai/v2/county/mine',
    })
}